import { LayoutSubmenuContentCP } from 'main/common/components/screen-layout-submenu/content/LayoutSubmenuContentCP'
import { HeaderCP } from 'submodules/nerit-framework-ui/common/components/screen/layout/header/HeaderCP'
import React, { useState } from 'react'
import { HeaderButtonICP } from 'main/common/components/screen-layout/header/inner/HeaderButtonICP'
import { TableTreatmentGroupCP } from 'main/modules/admin/components/table-treatment-group/TableTreatmentGroupCP'
import { ModalTreatmentGroupCP } from 'main/modules/products/components/modal-treatment-group/ModalTreatmentGroupCP'

/**
 * Tela de listagem de grupos de tratamentos.
 */
export function ScreenContentTreatmentGroupCP(): JSX.Element {

    const [shouldForceUpdateList, setShouldForceUpdateList] = useState<boolean>(true)
    const [isTreatmentDrawerVisible, setIsTreatmentDrawerVisible] = useState<boolean>(false)
    const [selectedTreatmentGroupCode, setSelectedTreatmentGroupCode] = useState<number>()

    return (
        <>
            <HeaderCP title={'Grupos de Atendimento'}>
                <HeaderButtonICP
                    onClick={() => {
                        setSelectedTreatmentGroupCode(undefined)
                        setIsTreatmentDrawerVisible(true)
                    }}
                    icon={'plus'}
                    label={'Novo Grupo de Atendimento'}
                />
            </HeaderCP>

            <LayoutSubmenuContentCP>
                <TableTreatmentGroupCP
                    forceLoadList={shouldForceUpdateList}
                    onListLoaded={() => setShouldForceUpdateList(false)}
                    onEdit={(code) => {
                        setIsTreatmentDrawerVisible(true)
                        setSelectedTreatmentGroupCode(code)
                    }}
                />
            </LayoutSubmenuContentCP>

            <ModalTreatmentGroupCP
                visible={isTreatmentDrawerVisible}
                treatmentGroupCode={selectedTreatmentGroupCode}
                onClose={(dataChanged) => {
                    if (dataChanged)
                        setShouldForceUpdateList(true)
                    setIsTreatmentDrawerVisible(false)
                }}
            />
        </>
    )
}
